import script from "./CongratulationsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CongratulationsPage.vue?vue&type=script&setup=true&lang=js"

import "./CongratulationsPage.vue?vue&type=style&index=0&id=21a7f0c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21a7f0c2"]])

export default __exports__